import React from 'react';
import { Helmet } from "react-helmet";
import { useLocation } from '../components/Router';
import {
  CFN_STAGE,
  CODEBUILD_BUILD_NUMBER,
  CODEBUILD_GIT_SHORT_ID,
  SITE_ROOT
} from '../api-config';
import log from 'loglevel';


const getCompany = (pageContext) => {
  const { exchange, symbol, securityName } = pageContext;

  if (!exchange || !symbol) {
    return null;
  }

  return {
    "@type": "Corporation",
    tickerSymbol: `${exchange} ${symbol}`,
    name: securityName
  };

};

const getEarningsConferenceCall = ({ event = {} }) => {
  const { year, quarter, conference_date } = event;

  if (!year || !quarter) {
    return null;
  }

  return {
    "@type": "BusinessEvent",
    name: `${quarter} ${year} conference call`,
    // conferenceDate: conference_date
  };

};

const logo = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "url": "https://earningscall.biz/",
  "logo": "https://earningscall.biz/EarningCall.png"
};

const getStructuredDataJson = (pageProps) => {
  const { pageContext = {} } = pageProps || {};
  const company = getCompany(pageContext);
  const earningsConferenceCall = getEarningsConferenceCall(pageContext);
  const data = {
    "@context": "https://schema.org",
    company,
    earningsConferenceCall
  };
  return JSON.stringify(data);
};

const getBlah = () => {

  const blah = {
      "@context": "https://schema.org",
      "@graph": [
          {
              "@type": "Corporation",
              "@id": "https://www.nasdaq.com/",
              "name": "Nasdaq",
              "url": "https://www.nasdaq.com/",
              "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.nasdaq.com/themes/nsdq/dist/assets/images/logo-half-white.svg"
              }
          },
          {
              "@type": "WebPage",
              "breadcrumb": {
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                      {
                          "@type": "ListItem",
                          "position": 1,
                          "name": "Home",
                          "item": "https://www.nasdaq.com/"
                      },
                      {
                          "@type": "ListItem",
                          "position": 2,
                          "name": "Market Activity",
                          "item": "https://www.nasdaq.com/market-activity"
                      },
                      {
                          "@type": "ListItem",
                          "position": 3,
                          "name": "Stocks",
                          "item": "https://www.nasdaq.com/market-activity/stocks"
                      }
                  ]
              }
          },
          {
              "@type": "WebSite",
              "name": "Nasdaq",
              "url": "https://www.nasdaq.com/",
              "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://www.nasdaq.com/search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
              }
          }
      ]
  };
  return blah;
};

const SiteHead = ({
    title,
    description: pageDescription,
    twitter: { cardTitle, description: cardDescription } = {},
    pageProps
  }) => {

  const { href } = useLocation();
  log.debug("SiteHead::render()", pageProps);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="application-name" content="EarningsCall"
        data-build-version={CODEBUILD_BUILD_NUMBER}
        data-commit-id={CODEBUILD_GIT_SHORT_ID}
        data-stage={CFN_STAGE}
      />
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={href} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="EarningsCall" />
      <meta property="og:image" content="https://earningscall.biz/android-chrome-512x512.png" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@EarningsCallApp" />
      <meta name="twitter:creator" content="@EarningsCallB0t" />
      <meta name="twitter:title" content={cardTitle || title} />
      <meta name="twitter:description" content={cardDescription || pageDescription} />
      <meta name="twitter:image" content={`${SITE_ROOT}/android-chrome-512x512.png`} />
      {/*
      <link rel="apple-touch-icon" sizes="180x180" href={`${SITE_ROOT}/apple-touch-icon.png`} />
      <link rel="icon" type="image/png" href={`${SITE_ROOT}/favicon-32x32.png`} sizes="32x32" />
      <link rel="icon" type="image/png" href={`${SITE_ROOT}/favicon-16x16.png`} sizes="16x16" />
      <link rel="manifest" href={`${SITE_ROOT}/site.webmanifest.json`} />
      */}
      <link rel="canonical" href={href} />
      <html lang="en" />
      <script type="application/ld+json">
        {getStructuredDataJson(pageProps)}
      </script>
    </Helmet>

  );
};

export default SiteHead;
